import Swiper from './swiper';

window.Swiper = Swiper;

require('./bootstrap4/tab');
require('./bootstrap4/collapse');
require('./bootstrap4/alert');
require('./bootstrap4/button');
require('./bootstrap4/tooltip');
require('./select2');
require('./jquery.magnific-popup.min');
require('./jquery.mask.min');
require('./jquery.validate');
require('nanoscroller');
require('air-datepicker');



// WEBPACK FOOTER //
// ./src/scripts/libs/index.js